export default __webpack_public_path__ + "static/media/m_session7_5.b20ccbff.png";